export const calculateAverageServiceDuration = (appointments) => {
  if (!appointments.length) return 0;
  return Math.round(
    appointments.reduce((sum, apt) => sum + (apt.duration || 60), 0) / appointments.length
  );
};

export const findMostFrequentService = (appointments) => {
  const serviceCounts = appointments.reduce((acc, apt) => {
    if (!apt.services) return acc;
    apt.services.forEach(service => {
      acc[service] = (acc[service] || 0) + 1;
    });
    return acc;
  }, {});

  return Object.entries(serviceCounts)
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count);
};

export const calculatePreferredDays = (appointments) => {
  const dayCount = appointments.reduce((acc, apt) => {
    const day = apt.dateTime.getDay();
    acc[day] = (acc[day] || 0) + 1;
    return acc;
  }, {});

  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return Object.entries(dayCount)
    .sort(([,a], [,b]) => b - a)
    .slice(0, 3)
    .map(([day]) => daysOfWeek[Number(day)]);
};

export const calculateCancellationRate = (appointments) => {
  if (!appointments.length) return 0;
  const cancelled = appointments.filter(apt => apt.status === 'cancelled').length;
  return Number(((cancelled / appointments.length) * 100).toFixed(1));
};

export const calculateLoyaltyPoints = (appointments) => {
  return appointments.reduce((points, apt) => {
    if (apt.status === 'completed') points += 10;
    if (apt.totalPrice) points += Math.floor(apt.totalPrice / 10);
    return points;
  }, 0);
};

/**
 * Formats a phone number to (XXX) XXX-XXXX format
 * @param {string} phone - Phone number string (can contain non-numeric characters)
 * @returns {string} Formatted phone number or original string if invalid
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  
  // Remove all non-numeric characters
  const cleaned = phone.replace(/\D/g, '');
  
  // If empty or invalid length, return empty
  if (cleaned.length === 0) return '';
  
  // Format based on length
  if (cleaned.length <= 3) {
    return cleaned;
  } else if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  } else {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  }
};

/**
 * Handles phone number input formatting as user types
 * @param {string} value - Current input value
 * @returns {string} Formatted phone number
 */
export const formatPhoneNumberInput = (value) => {
  if (!value) return '';
  
  // Remove all non-numeric characters
  const cleaned = value.replace(/\D/g, '');
  
  // Limit to 10 digits
  const limited = cleaned.slice(0, 10);
  
  // Format based on length
  if (limited.length === 0) return '';
  if (limited.length <= 3) {
    return limited;
  } else if (limited.length <= 6) {
    return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
  } else {
    return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6, 10)}`;
  }
};